import { styles } from "./PageProduct.style";

import * as React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { push } from "connected-react-router";

import { Grid, WithStyles, withStyles } from "@material-ui/core";
import { getProductDico } from "../../helper/functions.helper";
import { theme } from "../../theme/theme";

// import { Benchmark } from "../../types/Benchmark";
import { ProductName, ProductVariantName } from "../../types/Products";
import { RootState } from "../../types/RootState";

// import BenchmarkButton from "../../components/Benchmark/BenchmarkButton";
// import BenchmarkPopin from "../../components/Benchmark/BenchmarkPopin";
import Caret from "../../components/Caret/Caret";
import Conditions from "../../components/Conditions/Conditions";
import Cover from "../../components/Cover/Cover";
import Detail from "../../components/Detail/Detail";
import Plus from "../../components/Plus/Plus";
import Summary, { SummaryProps } from "../../components/Summary/Summary";
import Tools from "../../components/Tools/Tools";
import { PageConnected } from "../Page/Page";
import CalculatorButton from "../../components/Calculator/CalculatorButton";
import CalculatorPopin from "../../components/Calculator/CalculatorPopin";
import { User } from "../../models/User.model";

interface PageProductProps {
    name: ProductName;
    user: User;
    variant: ProductVariantName;
    push(): void;
}

interface PageProductState {
    // benchmarkPopinOpened: boolean;
    calculatorPopinOpened: boolean;
}

class PageProduct extends React.Component<PageProductProps & WithStyles<typeof styles>, PageProductState> {
    state = {
        // benchmarkPopinOpened: false,
        calculatorPopinOpened: false,
    };

    public render() {
        const { classes } = this.props;
        const dico = getProductDico(this.props.name, this.props.variant);

        return (
            <PageConnected
                cover={
                    <Cover
                        data={dico.cover}
                        push={this.props.push}
                        name={this.props.name}
                        variant={this.props.variant}
                    />
                }
            >
                <Grid container={true} className={classes.container}>
                    <Grid item={true} xs={9} className={classes.left}>
                        <Conditions list={dico.conditions} />
                        <Caret color={theme.palette.primary.main} />
                        <Plus list={dico.plus} />
                    </Grid>
                    <Grid item={true} xs={3}>
                        <Tools list={dico.docs} />
                        {/* <BenchmarkButton onClick={() => this.setState({ benchmarkPopinOpened: true })} /> */}
                        <CalculatorButton onClick={() => this.setState({ calculatorPopinOpened: true })} />
                        {/* <BenchmarkPopin
                            data={dico.benchmark as Benchmark}
                            open={this.state.benchmarkPopinOpened}
                            onClick={() => this.setState({ benchmarkPopinOpened: false })}
                        /> */}
                        <CalculatorPopin
                            user={this.props.user}
                            productName={this.props.name}
                            productVariantName={this.props.variant}
                            dico={dico}
                            open={this.state.calculatorPopinOpened}
                            onClick={() => this.setState({ calculatorPopinOpened: false })}
                        />
                    </Grid>
                </Grid>
                <Summary {...dico.summary as SummaryProps} />
                <div className={classes.container}>
                    <Detail data={dico.details} />
                </div>
            </PageConnected>
        );
    }
}

export const PageProductConnected = compose(
    withStyles(styles, { withTheme: true }),
    connect(
        (state: RootState, ownProps: PageProductState) => ({
            ...ownProps,
            user: state.me.user
        }),
        { push }
    )
)(PageProduct);

// For stories
export const PageProductStyled = withStyles(styles, { withTheme: true })(PageProduct);



// WEBPACK FOOTER //
// ./src/pages/PageProduct/PageProduct.tsx